export default __webpack_public_path__ + "img/unknown.d6e35e6e.png";